import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { HomepagelocalNigeriaService } from '../countryhomenigeria.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-form-section',
  templateUrl: './form-container.component.html',
  imports: [CommonModule, ToHtmlPipe],
})
export class FormSectionComponent implements OnInit, AfterViewInit {
  @Input() pageData:any;
  constructor(private homePageService: HomepagelocalNigeriaService) {}

  applyData: any;

  ngOnInit(): void {
    const data = this.pageData?.apply?.fields;
    if (data) {
      this.applyData = data;
      this.applyData = {
        title: data?.title,
        content: data?.content,
        formId: data?.component1?.[0]?.fields?.formId,
      };
    }
  }
  ngOnChanges(): void {
    const data = this.pageData?.apply?.fields;
    if (data) {
      this.applyData = data;
      this.applyData = {
        title: data?.title,
        content: data?.content,
        formId: data?.component1?.[0]?.fields?.formId,
      };
      this.loadHubspotForm();
    }
  }
  getFormId() {
    return this.applyData?.formId ? this.applyData?.formId : '';
  }
  ngAfterViewInit(): void {
    this.loadHubspotForm();
  }
  loadHubspotForm() {
    if (this.applyData && this.getFormId() !== '') {
      try {
        // @ts-ignore
        hbspt.forms.create({
          region: 'na1',
          portalId: '8646839',
          formId: this.getFormId(),
          target: '#hubspotDownloadForm',
          onFormReady: function ($form:any) {
            const fieldsets = $form[0].querySelectorAll('div.input');

            const submitButton = $form.find('input[type="submit"].hs-button');
            submitButton.css({
              padding: '16px',
              'border-radius': '10px',
              background: ' #359EB4',
              height: '48px',
              'font-size': '15px',
              'font-weight': '600',
              border: 'none',
              width: '100%',
            });
            submitButton.hover(
              function () {
                submitButton.css('background-color', '#2a7e90');
              },
              function () {
                submitButton.css('background-color', '#359eb4');
              }
            );
            const allInputs = $form[0].querySelectorAll('.hs-input');
            allInputs.forEach((input:any) => {
              if (input.type != 'checkbox') {
                input.style.height = '48px';
                input.style.borderRadius = '10px';
                input.style.border = '1px solid #E6E7E9';
                input.style.background = '#FFF';
              }
            });
          },
        });
      } catch (_) {}
    }
  }
}
